import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Message} from 'semantic-ui-react';

class AttachMessage extends Component {
  getColor() {
    const {error, success} = this.props;

    if (error) {
      return 'red';
    }

    if (success) {
      return 'green';
    }
    return null;
  }

  render() {
    const {error, success} = this.props;
    
    if (!error && !success) {
      return null;
    }

    return (
      <Message color={this.getColor()}>
        {error || success}
      </Message>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'error': state.returnClaim.attachError,
    'success': state.returnClaim.attachSuccess,
  };
};

export default connect(mapStateToProps)(AttachMessage);
